<template>
  <div class="wizard-container">
    <div class="container">
      <div class="project-wrapper row justify-content-between">
        <h5>Erstellte Inlays</h5>
        <div
          class="inlays col-2 mt-2 mb-2"
          v-for="(inlay, index) in currentProject"
          :key="index"
        >
          {{ inlay.name }}
        </div>
        <div class="row">
          <div class="d-grid gap-2 w-25">
            <button
              type="button"
              name=""
              id=""
              class="btn btn-primary"
              @click="addNewInlay"
            >
              Neues Inlay hinzufügen
            </button>
          </div>
        </div>
      </div>
      <div class="row form-wrapper mt-4">
        <div class="container col-8">
          <form @submit.prevent="onSubmit">
            <div class="mb-3 row">
              <label for="inputName" class="col col-form-label">Name</label>
              <div class="col-10">
                <input
                  type="text"
                  class="form-control"
                  name="inputName"
                  id="inputName"
                  placeholder="Name"
                />
              </div>
            </div>
            <div class="mb-3 row">
              <label for="inputName" class="col col-form-label">Straße</label>
              <div class="col-10">
                <input
                  type="text"
                  class="form-control"
                  name="inputStrasse"
                  id="inputStrasse"
                  placeholder="Straße"
                />
              </div>
            </div>
            <div class="mb-3 row">
              <label for="inputName" class="col col-form-label">PLZ</label>
              <div class="col-2">
                <input
                  type="number"
                  class="form-control"
                  name="inputPLZ"
                  id="inputPLZ"
                  placeholder="PLZ"
                />
              </div>
              <label for="inputName" class="col col-form-label">Stadt</label>
              <div class="col-6">
                <input
                  type="text"
                  class="form-control"
                  name="inputStadt"
                  id="inputStadt"
                  placeholder="Stadt"
                />
              </div>
            </div>
            <div class="mb-3 row">
              <label for="inputName" class="col col-form-label">Email</label>
              <div class="col-10">
                <input
                  type="email"
                  class="form-control"
                  name="inputEmail"
                  id="inputEmail"
                  placeholder="Email"
                />
              </div>
            </div>
            <fieldset class="mb-3 row">
              <legend class="col-form-legend col-4">Group name</legend>
              <div class="col-8">you can use radio and checkboxes here</div>
              <div v-if="successful">
                <span class="text-success">Nachricht abgeschickt</span>
              </div>
            </fieldset>
            <div class="mb-3 row">
              <div class="offset-sm-4 col-sm-8">
                <button type="submit" class="btn btn-primary">Absenden</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { saveInlay } from "@/modules/saveInlay.js";
import http from "./axios.js";
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const successful = ref(true);
    const currentProject = computed(() => store.getters.currentProject);
    function addNewInlay() {
      store.dispatch("setCurrentInlay", {});
      router.push("/wizard");
    }

    function onSubmit(e) {
      e.preventDefault();
      let formData = new FormData(e.target);
      let zip = new JSZip();
      currentProject.value.forEach((inlay) => {
        let saved_inlay = saveAll(inlay);
        zip.file(saved_inlay.name + ".html", saved_inlay.html);
        // formData.append(saved_inlay.name + ".html", saved_inlay.html);
      });
      zip.generateAsync({ type: "blob" }).then(function (content) {
        formData.append(
          "file",
          content,
          e.target["inputName"].value + "_Wizard.zip"
        );
        let config = {
          header: {
            "Content-Type": "multipart/form-data",
          },
        };
        http.post("/email", formData, config).then((response) => {
          if (response.status == 200) {
            successful.value = true;
          }
        });
      });
    }
    function saveAll(inlay) {
      return saveInlay(inlay);
    }
    return { currentProject, addNewInlay, onSubmit };
  },
};
</script>

<style lang="scss" scoped>
.container {
}
.wizard-container {
  background: white;
  height: calc(100vh - 80px);
  width: 100vw;
}
</style>
